(function documentModuleDefinition() {
    'use strict';

    angular.module('Document', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'ui.select', 'ui.selectExtend',
                                'ngFileUpload', 'CustomControls', 'ClickOnce', 'FileDownloader', 'Alerts', 'TranslatedPaginator', 'Actions', 
                                'TwainCapture', 'DoublyLinkedList', 'DocumentContainer', 'DocumentViewer'])
        .config(['configProvider', '$stateProvider', 'loginProvider',
            function documentConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('document-add', {
                    url: "/Document/Add",
                    templateUrl: config.resourceUrl('/views/document/add-modify.html'),
                    controller: 'DocumentAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-add-multiple', {
                    url: "/Document/AddMultiple",
                    templateUrl: config.resourceUrl('/views/document/add-multiple.html'),
                    controller: 'DocumentAddMultipleController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-add-multiple-digitalized', {
                    url: "/Document/AddMultipleDigitalized",
                    templateUrl: config.resourceUrl('/views/document/add-multiple-digitalized.html'),
                    controller: 'DocumentAddMultipleDigitalizedController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT MASSIVE DIGITALIZATION').and('DOCUMENT WRITE')
                });

                /*
                $stateProvider.state('document-digitalize-indexing', {
                    url: "/Document/DigitalizeIndexing",
                    templateUrl: config.resourceUrl('/views/document/digitalize-indexing.html'),
                    controller: 'DocumentDigitalizeIndexingController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT MASSIVE DIGITALIZATION').and('DOCUMENT WRITE')
                });
                */
                $stateProvider.state('document-modify', {
                    url: "/Document/Modify/{id}",
                    templateUrl: config.resourceUrl('/views/document/add-modify.html'),
                    controller: 'DocumentModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-find', {
                    url: "/MyDocument/List",
                    templateUrl: config.resourceUrl('/views/document/my-list.html'),
                    controller: 'DocumentFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('mydocument-detail', {
                    url: '/MyDocument/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document/detail.html'),
                    controller: 'DocumentDetailController',
                    authorize: true,
                    resolve: {
                        myDocument: function () {
                            return true;
                        }
                    },
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-detail', {
                    url: '/Document/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document/detail.html'),
                    controller: 'DocumentDetailController',
                    authorize: true,
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-detail-container', {
                    url: '/DocumentContainer/{containerId}/Document/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document/detail.html'),
                    controller: 'DocumentDetailController',
                    params: { containreModify: null },
                    authorize: true,
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('mydocument-detail-container', {
                    url: '/DocumentContainer/{containerId}/MyDocument/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document/detail.html'),
                    controller: 'DocumentDetailController',
                    authorize: true,
                    resolve: {
                        myDocument: function () {
                            return true;
                        }
                    },
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-version-detail', {
                    url: '/Document/{id}/Version/Detail/{nro}',
                    templateUrl: config.resourceUrl('/views/document/detail.html'),
                    controller: 'DocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('document-version-all', {
                    url: '/Document/{id}/Version/Detail',
                    templateUrl: config.resourceUrl('/views/document/versions-detail.html'),
                    controller: 'DocumentVersionsController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTVERSION READ')
                });


                $stateProvider.state('document-advanced-find', {
                    url: "/Document/Find",
                    templateUrl: config.resourceUrl('/views/document/list.html'),
                    controller: 'DocumentAdvancedFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENT WRITE').or('DOCUMENTVERSIONED WRITE')
                });

                $stateProvider.state('share-document', {
                    url: "/Document/Share/{id}",
                    templateUrl: config.resourceUrl('/views/document/share.html'),
                    controller: 'DocumentShareController',
                    authorize: true,
                    roles: loginProvider.roleCondition(['SHARE', 'DOCUMENT READ']).or(['SHARE', 'DOCUMENT WRITE']).or(['SHARE', 'DOCUMENTVERSIONED WRITE'])
                });

                $stateProvider.state('document-detail-images', {
                    url: '/Document/Detail/Images/{id}',
                    templateUrl: config.resourceUrl('/views/document/detail-images.html'),
                    controller: 'DocumentDetailImagesController',
                    authorize: true,
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    roles: loginProvider.roleCondition('DOCUMENT IMAGE READ')
                });

                $stateProvider.state('mydocument-detail-images', {
                    url: '/MyDocument/Detail/Images/{id}',
                    templateUrl: config.resourceUrl('/views/document/detail-images.html'),
                    controller: 'DocumentDetailImagesController',
                    authorize: true,
                    resolve: {
                        myDocument: function () {
                            return true;
                        }
                    },
                    roles: loginProvider.roleCondition('DOCUMENT IMAGE READ')
                });                
            }
        ]);
})();